import React, {useState, useEffect} from 'react';
import { useForm } from 'react-hook-form';
import { Save, Upload, ExternalLink, FileText, Hash } from 'lucide-react';
import HomeNavbarmenu from '../HomeFolder/HomeNavbarmenu';
import HomeSideNavbar from '../HomeFolder/HomeSideNavbar';
import ImageGalleryModal from './ImageGallery/ImageGalleryModal';
import axios from "axios";
import { baseUrl } from '../../Constants';

// const images = [
//   "images/Home/ATCI SAP T20.png",
//   "images/Home/DFA.png",
//   "images/Home/Sustainability learning.png",
//   "images/Home/Senior-Analyst-Experience-School.png",
//   "images/Home/Team-Lead-Experience-School.png",
//   "images/Home/Associate-Manager-Experience-School.png",
//   "images/Home/Manager-Experience-School.png",
//   "images/Home/Senior-Manager-Experience-School.png",
//   "images/Home/AMS-Primer-Class.png",
//   "images/Home/AMS-Adept-Class.png",
//   "images/Home/ServiceNow-101.png",
//   "images/Home/Project-Management-Foundation-School.png",
//   "images/Home/Project-Management-Advanced-School.png",
//   "images/Home/Agile-Project-Management.png",
//   "images/Home/Project-Management-Micromodules-101-Series.png",
//   // Add more paths as needed
// ];

const images = [
  "images/Home/Featured/atci-sap-new.png",
  "images/Home/Featured/dfa-new.png",
  "images/Home/Featured/sustainability-new.png",
  "images/Home/Featured/saes-new.png",
  "images/Home/Featured/tles-new.png",
  "images/Home/Featured/ames-new.png",
  "images/Home/Featured/Manager-Experience-School.png",
  "images/Home/Featured/Senior-Manager-Experience-School.png",
  "images/Home/Featured/AMS-Primer-Class.png",
  "images/Home/Featured/AMS-Adept-Class.png",
  "images/Home/Featured/ServiceNow-101.png",
  "images/Home/Featured/Project-Management-Foundation-School.png",
  "images/Home/Featured/Project-Management-Advanced-School.png",
  "images/Home/Featured/Agile-Project-Management.png",
  "images/Home/Featured/Project-Management-Micromodules-101-Series.png",
  "images/Home/Featured/SI-Foundation-Class.png",
  "images/Home/Featured/Building-Client-Centricity.png",
  "images/Home/Featured/Understanding-Client-Centricity.png",
  "images/Home/Featured/Delivery-Sales-Academy.png",
  "images/Home/Featured/Delivery-Lead-Essentials.png",
  "images/Home/Featured/Agile-Coaching-Academy.png",
  "images/Home/Featured/Agile-for-Product-Managers.png",
  "images/Home/Featured/SecurEarn2.png",
  "images/Home/Featured/Agentic-AI.png",
];


// Custom validation functions
const validateId = (value) => {
    if (!value) return 'ID is required';
    if (!/^\d+$/.test(value)) return 'ID must be a number';
    return true;
};

const validateFeaturedIcon = (value) => {
    console.log("featuredicon path", value);
    
    if (!value) return 'Featured icon path is required';
    return true;
};

const validateTitle = (value) => {
    if (!value) return 'Title is required';
    if (value.length < 3) return 'Title must be at least 3 characters';
    if (value.length > 50) return 'Title must be less than 50 characters';
    return true;
};

const validateContent = (value) => {
    if (!value) return 'Content is required';
    if (value.length < 100) return 'Content must be at least 100 characters';
    if (value.length > 300) return 'Content must be less than 300 characters';
    return true;
};

const validateUrl = (value) => {
    if (!value) return 'URL is required';
    try {
        new URL(value);
        return true;
    } catch {
        return 'Please enter a valid URL';
    }
};

const axiosUpdateCall = async(data, id, getFeaturedProg) => {

    console.log("updatedata", data);
    

    const body = {
        "id" : id,
        "title" : data.title,
        "description" : data.content,
        "know_more_url" : data.knowmore,
        "featuredicon" : data.featuredicon
    }

    try {
        const res = await axios.post(`${baseUrl}/updatefeaturedprog`, body,
            {
                headers: {
                    Authorization: localStorage.getItem("token"),
                    "Content-Type": "application/json",
                },
            }
        );
        getFeaturedProg();
    } catch (err) {
        console.error(err);
    }
}

const axiosPostCall = async(data, getFeaturedProg) => {

    console.log("thisss one", data);
    
    // const baseURL = "https://atci.lkm.accenture.com/lttmicrosite-apis"
    // const baseURL = "http://localhost:3046"


    const body = {
        "title" : data.title,
        "description" : data.content,
        "know_more_url" : data.knowmore,
        "featuredicon" : data.featuredicon
    }

    try {
        const res = await axios.post(`${baseUrl}/addfeaturedprog`, body,
                        {
                headers: {
                    Authorization: localStorage.getItem("token"),
                    "Content-Type": "application/json",
                },
            }
        );
        getFeaturedProg();
    } catch (err) {
        console.error(err);
    }
}

const AddFeaturedProgram = ({
    onSubmit = (data) => {
        console.log("data on submit", data);

        if(item){

            axiosUpdateCall(data, item.id, getFeaturedProg);
        }else{
         
            axiosPostCall(data, getFeaturedProg);
        }
        setaddFeaturePopup(false);
    },
    initialData,
    setaddFeaturePopup,
    item,
    getFeaturedProg
}) => {
    const {
        register,
        handleSubmit,
        formState: { errors, isSubmitting },
        reset,
        watch,
        setValue
    } = useForm({
        defaultValues: initialData || {
            featuredicon: '',
            title: '',
            content: '',
            knowmore: ''
        }
    });

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedImage, setSelectedImage] = useState("");

    const watchedContent = watch('content', '');

    const onFormSubmit = async (data) => {
        try {
            await onSubmit(data);
            // Optional: Reset form after successful submission
            // reset();
        } catch (error) {
            console.error('Error submitting form:', error);
        }
    };


  const handleImageSelect = (src) => {
    setSelectedImage(src);
    setValue('featuredicon', src, { shouldValidate: true });
  };
  

    useEffect(() => {
    register('featuredicon', { validate: validateFeaturedIcon });
  }, [register]);

    useEffect(() => {
        console.log("edititem received",item);
        
        if(item){
            handleImageSelect(item.featuredicon);
            setValue('title', item.title);
            setValue('content', item.description);
            setValue('knowmore', item.know_more_url);
        }
  }, []);

    return (

        <>
                <div className="form-container">
                    <div className="form-header">
                        <h2 className="form-title">Add Featured Program</h2>
                        <div className="form-description">Create a new featured program entry with all required details.</div>
                    </div>

                    <form onSubmit={handleSubmit(onFormSubmit)} className="form">
                        
                    <div className="split-form">
                        <div className="form-column">

                        {/* Title */}
                        <div className="field-group">
                            <label htmlFor="title" className="field-label">
                                <FileText className="field-icon" />
                                Program Title
                            </label>
                            <input
                                {...register('title', { validate: validateTitle })}
                                // value={item ? item.title : ''}
                                type="text"
                                id="title"
                                placeholder="e.g., ATCI SAP T20 Certified League"
                                className={`field-input ${errors.title ? 'error' : ''}`}
                                aria-label="title"
                            />
                            {errors.title && (
                                <div className="error-message">
                                    <span className="error-dot"></span>
                                    {errors.title.message}
                                </div>
                            )}
                        </div>

                        {/* Content */}
                        <div className="field-group">
                            <label htmlFor="content" className="field-label-with-counter">
                                <span className="field-label">
                                    <FileText className="field-icon" />
                                    Program Description
                                </span>
                                <span className="character-counter">
                                    {watchedContent.length}/300
                                </span>
                            </label>
                            <textarea
                                {...register('content', { validate: validateContent })}
                                id="content"
                                // value={item ? item.description : ''}
                                rows={4}
                                placeholder="An exclusive program to elevate SAP expertise, designed for certified professionals and aspiring SAP experts, with exciting activities and certifications."
                                className={`field-textarea ${errors.content ? 'error' : ''}`}
                            />
                            {errors.content && (
                                <div className="error-message">
                                    <span className="error-dot"></span>
                                    {errors.content.message}
                                </div>
                            )}
                        </div>

                        </div>
                        <div className="form-column">
                                                    {/* Know More URL */}
                        <div className="field-group">
                            <label htmlFor="knowmore" className="field-label">
                                <ExternalLink className="field-icon" />
                                Know More URL
                            </label>
                            <input
                                {...register('knowmore', { validate: validateUrl })}
                                type="url"
                                id="knowmore"
                                // value={item ? item.know_more_url : ''}                                
                                placeholder="https://atci.lkm.eitacademy.accenture.com/SAPAscend/Events"
                                className={`field-input ${errors.knowmore ? 'error' : ''}`}
                                aria-label="link"
                            />
                            {errors.knowmore && (
                                <div className="error-message">
                                    <span className="error-dot"></span>
                                    {errors.knowmore.message}
                                </div>
                            )}
                        </div>

                        
                        {/* Image Gallery */}
                                                {/* Featured Icon Path */}
                        <div className="field-group">
                            <label htmlFor="featuredicon" className="field-label">
                                <Upload className="field-icon" />
                                Featured Icon Path
                            </label>
                            {/* <input
                                {...register('featuredicon', { validate: validateFeaturedIcon })}
                                type="text"
                                id="featuredicon"
                                placeholder="e.g., images/Home/ATCI SAP T20.png"
                                className={`field-input ${errors.featuredicon ? 'error' : ''}`}
                                aria-label="icon"
                            /> */}

                            <div>
                                {selectedImage && (
                                    <img src={selectedImage} alt="Selected" style={{ width: 100 }} />
                                )}
                                <button 

                                className="choose-image-btn" type="button" onClick={() => setIsModalOpen(true)}>
                                    Choose Image
                                </button>
                            </div>


                            {errors.featuredicon && (
                                <div className="error-message">
                                    <span className="error-dot"></span>
                                    {errors.featuredicon.message}
                                </div>
                            )}
                        </div>

                        <ImageGalleryModal
                            isOpen={isModalOpen}
                            onClose={() => setIsModalOpen(false)}
                            onSelect={handleImageSelect}
                            imagesrc={item ? item.featuredicon : null}
                            images={images}
                        />
                        </div>
                    </div>





                        {/* Submit Button */}
                        <div className="button-group-addevent">
                            <button
                                type="submit"
                                disabled={isSubmitting}
                                className="submit-button"
                            >
                                {isSubmitting ? (
                                    <>
                                        <div className="loading-spinner"></div>
                                        Saving...
                                    </>
                                ) : (
                                    <>
                                        <Save className="button-icon" />
                                        Save Program
                                    </>
                                )}
                            </button>

                            <button
                                type="button"
                                onClick={() => setaddFeaturePopup(false)}
                                className="cancel-button"
                            >
                                Cancel
                            </button>
                        </div>
                    </form>
                </div>
 
        </>

    );
};

export default AddFeaturedProgram;